@if (incomeTaxEntity$ | async) {
  <form [formGroup]="formGroup">
    <div formArrayName="ontvangenPU">
      @for (item of opbrengsten.controls; track item; let i = $index) {
        <div [formGroupName]="i" class="row" style="--bs-gutter-x: 0.5rem;">
          <div class="col-auto row" style="--bs-gutter-x: 0.5rem;">
            <snelstart-ui-text-form-control [label]="i === 0 ? 'Omschrijving uitkering' : ''"
                                            class="col-auto custom-input-250"
                                            formControlName="omschrijving"
                                            id="omschrijving"
            >
            </snelstart-ui-text-form-control>
            <snelstart-ui-number-form-control [decimals]="0"
                                              [label]="i === 0 ? 'Bedrag' : ''"
                                              align="right"
                                              class="col-auto custom-input-150"
                                              formControlName="bedrag"
                                              id="bedragRow"
                                              prefix="€"

            >
            </snelstart-ui-number-form-control>
            <snelstart-ui-button (click)="verwijderRijOpbrengsten(i)"
                                 [class]="i === 0 ? 'firstrowbutton' : ''"
                                 class="col-auto"
                                 icon="trash"
                                 id="buttonDeleteKosten"
                                 size="medium"
                                 type="secondary"
            >
            </snelstart-ui-button>
          </div>
        </div>
      }
    </div>

    <snelstart-ui-button (click)="addRijOpbrengsten()" class="snelstart-ui-button pb-3" icon="plus"
                         type="link">Ontvangen uitkering toevoegen
    </snelstart-ui-button>

    <div formArrayName="kostenPU">
      @for (item of kosten.controls; track item; let i = $index) {
        <div [formGroupName]="i" class="row" style="--bs-gutter-x: 0.5rem;">
          <div class="col-auto row" style="--bs-gutter-x: 0.5rem;">
            <snelstart-ui-text-form-control [label]="i === 0 ? 'Omschrijving kosten' : ''"
                                            class="col-auto custom-input-250"
                                            formControlName="omschrijving"
            >
            </snelstart-ui-text-form-control>
            <snelstart-ui-number-form-control [decimals]="0"
                                              [label]="i === 0 ? 'Bedrag' : ''"
                                              align="right"
                                              class="col-auto custom-input-150"
                                              formControlName="bedrag"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
            <snelstart-ui-button (click)="verwijderRijKosten(i)"
                                 [class]="i === 0 ? 'firstrowbutton' : ''"
                                 class="col-auto"
                                 icon="trash"
                                 size="medium"
                                 type="secondary"
            >
            </snelstart-ui-button>
          </div>
        </div>
      }
    </div>
    <snelstart-ui-button (click)="addRijKosten()" class="snelstart-ui-button pb-3" icon="plus"
                         type="link">Kosten uitkering toevoegen
    </snelstart-ui-button>

    @if (opbrengsten.length > 1) {
      <div class="col-auto row">
        <snelstart-ui-text-form-control [disabledControl]=true
                                        class="custom-input-250"
                                        formControlName="omschrijving"
                                        id="description"
                                        label="Omschrijving"
        >
        </snelstart-ui-text-form-control>
        <snelstart-ui-number-form-control [decimals]="0"
                                          align="right"
                                          class="custom-input-150"
                                          formControlName="revisierente"
                                          id="revisierente"
                                          label="Bedrag"
                                          prefix="€">
        </snelstart-ui-number-form-control>
      </div>
    }
  </form>
}
